import React from "react";
import { graphql } from "gatsby";

import Meta from "@components/Meta";

import { InitialColorProvider } from "@components/layout/SectionColor";
import { BuildEffects } from "@components/transition";
import Rule from "@components/Rule";
import Star from "@components/Star";

import styles from "./contact.module.scss";

import data from "@placeholder-data/contact";
import { ParseContactPage } from "@js-utils/contentful/contact";

// Format an 11-digit phone number
function formatPhone(number) {
  if (number.length !== 11) return number;
  return `+${number.slice(0, 1)} ${number.slice(1, 4)} ${number.slice(4, 7)} ${number.slice(7)}`;
}

function formatContactLine({ title, name, phone, email }) {
  return (
    <BuildEffects.FadeUp el="article" className={styles.contactLine}>
      <h2 className={styles.eyebrow}>{title}</h2>
      {name && <p>{name}</p>}
      {phone && <a href={`tel:${phone}`}>{formatPhone(phone)}</a>}
      {email && <a href={`mailto:${email}`}>{email}</a>}
    </BuildEffects.FadeUp>
  );
}

export default function ContactPage(props) {
  const { ruleLabel, heading, contactLines } = ParseContactPage(props.data.contentfulContactPage);
  const { pageMeta } = props.data.contentfulContactPage;

  return (
    <>
      <Meta pageTitle={"Contact"} pageMeta={pageMeta} />
      <section
        className={styles.base}
        data-page-background-color="var(--color-black)"
        data-page-accent-color="var(--color-green)"
        data-page-is-dark
      >
        <InitialColorProvider
          backgroundColor="var(--color-black)"
          accentColor="var(--color-green)"
          isDark
        />

        <header>
          <BuildEffects.RuleWipe className={styles.rule}>
            <Rule>{ruleLabel}</Rule>
          </BuildEffects.RuleWipe>
          <h1>
            <BuildEffects.TextMask>{heading}</BuildEffects.TextMask>
          </h1>
          <BuildEffects.FadeUp className={styles.starContainer}>
            <Star spec="lg" className={styles.star} />
          </BuildEffects.FadeUp>
        </header>

        <BuildEffects.FadeUp el="article" className={styles.location}>
          <h2 className={styles.eyebrow}>Location</h2>
          <div className={styles.address}>{data.location.trim()}</div>
        </BuildEffects.FadeUp>

        {data.contactLines[0] && formatContactLine(data.contactLines[0])}
        {data.contactLines[1] && formatContactLine(data.contactLines[1])}
      </section>
    </>
  );
}

export const PageQuery = graphql`
  query ContactQuery {
    contentfulPageMeta(id: { eq: "792afa4c-aab1-553f-b96e-49f0d5ad3909" }) {
      ...DefaultMeta
    }
    contentfulContactPage {
      pageMeta {
        ...PageMetaData
      }
      id
      eyebrow
      headline {
        headline
      }
      title
      content {
        title
        content {
          childMarkdownRemark {
            html
          }
        }
      }
    }
  }
`;
